<template>
    <div :id="`input_${name}`" class="upload-group">
        <div class="upload-control" @click="$_selectFile">
            <em class="fas fa-plus-circle upload-icon"></em>
            <span :id="`selected_${name}`" class="upload-name">{{
                selectedFile
            }}</span>
        </div>
        <input
            v-bind="$attrs"
            ref="fileSelector"
            v-show="false"
            type="file"
            :accept="accept"
            :id="name"
            :name="name"
            @change="$_onFileSelected"
            :data-fieldname="name"
        />
    </div>
</template>

<script>
    import modalMixin from '../../components/Mixins/ModalMixin.vue';

    export default {
        mixins: [modalMixin],
        props: {
            name: { type: String, default: 'Upload-input' },
            fileName: { type: String },
            maxSize: { type: Number, default: 20971520 }, // 20MB default
            maxSizeText: { type: String, default: '20MB' },
            accept: { type: String, default: '.*' },
            acceptedExtensions: { type: Array, default: () => [] }
        },
        data() {
            return { file: null };
        },
        computed: {
            selectedFile() {
                return this.file ? this.file.name : this.$t('labelNoFileSelected');
            }
        },
        methods: {
            $_selectFile() {
                this.$refs.fileSelector.click();
            },
            $_onFileSelected(event) {
                const files = event.currentTarget.files;
                if (files.length === 0) return;

                const selected = files[0];

                // Size check
                if (selected.size > this.maxSize) {
                    this.showToast({
                        message: this.$t('errorFileTooLarge', [this.maxSizeText]),
                        variant: 'danger',
                        title: this.$t('errorFileUpload'),
                        autoHideDelay: 10000
                    });
                    return;
                }

                // Extension check
                if (
                    this.acceptedExtensions.length > 0 &&
                    !this.acceptedExtensions.includes(
                        selected.name.split('.').pop()
                    )
                ) {
                    this.showToast({
                        message: this.$t('errorWrongExtension'),
                        variant: 'danger',
                        title: this.$t('errorFileUpload'),
                        autoHideDelay: 10000
                    });
                    return;
                }

                this.file = selected;
                // Emit the raw File object
                this.$emit('selected', selected);
            }
        },
        watch: {
            fileName(newValue) {
                if (!newValue) {
                    this.file = null;
                    this.$refs.fileSelector.value = null;
                }
            }
        }
    };
</script>

<style scoped>
.upload-group {
    display: block;
    margin: 0px;
    padding: 0px;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
}

.upload-control {
    background: #fff;
    cursor: pointer;
    border-radius: 0.25rem;
}

.upload-icon {
    color: #007ac9;
    margin-left: 10px;
}

.upload-name {
    margin-left: 10px;
    margin-right: 15px;
}
</style>
